import React from 'react';
import CompanyForm from "../../components/CompanyForm";
import {Container, Typography} from "@mui/material";
import {api} from "../../services/apiService";


export default function CreateCompany(props) {

    const handleSubmit = (data, logo) => {
        const formData = new FormData();

        if (logo) {
            formData.append('logo', logo);
        }

        // on envoie le JSON sérialisé dans un champ 'data'
        data.tva = data.tva_number; // adapter le nom du champ
        data.name = data.companyName; // adapter le nom du champ
        formData.append('data', JSON.stringify(data));

        // axios gère normalement le boundary automatiquement, mais on peut forcer le type multipart/form-data
        return api.post(`/companies/add_company`, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        }).then((response) => {
            alert("Entreprise créée avec succès !");
        }).catch(err => {
            alert("Erreur lors de la création de l'entreprise : " + err.message);
        });
    }

    return (
        <Container>
            <Typography variant="h1">Création d'une entreprise</Typography>

            <CompanyForm onSubmit={handleSubmit}/>
        </Container>
    );
}